import { useContext } from "react";
import { ErrorDialogContext, /**errorHandledAsync,*/ errorHandledSync, } from "@/shared/context/error-context";
import { UpdateUserInfoService } from "@/features/user/services/update-user-info-service";
import { MoneyLinkError, MoneyLinkException, ErrorLevel } from "@/shared/utils/custom-exception";
import { useLoginContext } from "@/features/auth/contexts/login-context";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";

interface Props {
  onTapCompleteModal: () => void;
}

export const useUpdateUserInfo = ({ onTapCompleteModal }: Props) => {
  const updateUserInfoService = new UpdateUserInfoService();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  const {
    setUserName,
  } = useLoginContext();

  const loadingCtx = useContext(LoadingModalContext);

  const onClickUpdate = async (
    userName?: string,
    isReceiveMail?: boolean,
    isReceiveErrorMail?: boolean,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      if (userName === undefined
        && isReceiveMail === undefined
        && isReceiveErrorMail === undefined
      ){
        return;
      }

      await updateUserInfoService.updateUserInfo({
        ...(userName !== undefined && { owner_name: userName }),
        ...(isReceiveMail !== undefined && { is_receive_mail: isReceiveMail }),
        ...(isReceiveErrorMail !== undefined && { is_receive_error_mail: isReceiveErrorMail }),
      });

      if (userName)
      {
        sessionStorage.setItem("userName", userName);
        setUserName(userName);
      }

      onTapCompleteModal();
    } catch (error) {
      console.log(error);
      if (
        error instanceof MoneyLinkException &&
        error.error.props.reason === "webmoneylink_parameter_error"
      ) {
        throw new MoneyLinkException({
          error: new MoneyLinkError({
            level: ErrorLevel.Warn,
            code: error.error.props.code,
            reason: error.error.props.reason,
            messageTitle: undefined,
            messageBody:
              "ユーザー名に使用できない文字が含まれているか、文字数が上限を超えています。\n入力内容をご確認ください。",
          }),
        });
      }
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  // ユーザー名変更イベント
  const onChangeUserName = (value: string) => {
    setUserName(value);
  };

  return {
    onClickUpdate: errorHandledSync(onClickUpdate, setError),
    onChangeUserName: errorHandledSync(onChangeUserName, setError),
  };
};
